// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Dashboard Page ===== */
/* Matches the existing site design (charts-overview.css, chart-main.css patterns) */

.db-page {
  padding: 2rem;
  background: transparent;
  min-height: 100vh;
  color: #ffffff;
  box-sizing: border-box;
}

/* ===== Header / Tabs ===== */

.db-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  gap: 16px;
  flex-wrap: wrap;
}

.db-tabs {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  flex: 1 1;
  min-width: 0;
}

.db-tabs::-webkit-scrollbar { display: none; }

.db-tab {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(51, 51, 51, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  cursor: pointer;
  white-space: nowrap;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}

.db-tab:hover {
  background: rgba(75, 85, 99, 0.4);
  border-color: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.db-tab.active {
  background: rgba(139, 92, 246, 0.2);
  border-color: rgba(139, 92, 246, 0.5);
  color: #fff;
  box-shadow: 0 4px 20px rgba(139, 92, 246, 0.2);
}

.db-tab-input {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(139, 92, 246, 0.5);
  border-radius: 4px;
  padding: 2px 8px;
  color: #fff;
  font-size: 13px;
  font-family: inherit;
  outline: none;
  width: 120px;
}

.db-tab-delete {
  display: none;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: rgba(255, 100, 100, 0.7);
  padding: 0;
  margin-left: 2px;
  font-size: 12px;
  line-height: 1;
  transition: all 0.15s;
}

.db-tab:hover .db-tab-delete { display: flex; }
.db-tab-delete:hover { color: #f87171; }

.db-tab-add {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(51, 51, 51, 0.3);
  backdrop-filter: blur(10px);
  cursor: pointer;
  color: rgba(255, 255, 255, 0.6);
  font-size: 18px;
  line-height: 1;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.db-tab-add:hover {
  background: rgba(139, 92, 246, 0.2);
  border-color: rgba(139, 92, 246, 0.5);
  color: #c4b5fd;
}

.db-edit-badge {
  padding: 4px 10px;
  background: rgba(139, 92, 246, 0.2);
  border: 1px solid rgba(139, 92, 246, 0.4);
  border-radius: 6px;
  font-size: 11px;
  color: #c4b5fd;
  animation: db-pulse 2s infinite;
}

@keyframes db-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.db-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.db-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  color: #ffffff;
  cursor: pointer;
  font-size: 13px;
  font-family: inherit;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.db-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.db-btn-primary {
  background: rgba(139, 92, 246, 0.25);
  border-color: rgba(139, 92, 246, 0.5);
  color: #c4b5fd;
}

.db-btn-primary:hover {
  background: rgba(139, 92, 246, 0.35);
  border-color: rgba(139, 92, 246, 0.7);
  color: #ddd6fe;
}

.db-btn-danger {
  background: rgba(239, 68, 68, 0.15);
  border-color: rgba(239, 68, 68, 0.4);
  color: #fca5a5;
}

.db-btn-danger:hover {
  background: rgba(239, 68, 68, 0.25);
  border-color: rgba(239, 68, 68, 0.6);
}

/* ===== Favorites Bar ===== */

.db-favorites {
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 20px 20px 16px;
  margin-bottom: 1.5rem;
  box-shadow: -2px 0 2px rgba(255,255,255,0.15), 2px 0 2px rgba(255,255,255,0.15);
  border-left: 1px solid rgba(255,255,255,0.08);
  border-right: 1px solid rgba(255,255,255,0.08);
  border-top: 1px solid rgba(255,255,255,0.04);
  border-bottom: 1px solid rgba(255,255,255,0.04);
}

.db-favorites-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  font-weight: 500;
}

.db-favorites-grid {
  display: flex;
  flex-direction: row;
  gap: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.db-favorites-grid::-webkit-scrollbar {
  display: none;
}

.db-fav-card {
  flex: 1 1 170px;
  min-width: 160px;
  max-width: 220px;
  background: rgba(30, 30, 50, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.db-fav-card:hover {
  background: rgba(40, 40, 60, 0.7);
  border-color: rgba(139, 92, 246, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.15);
}

.db-fav-name {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.db-fav-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.db-fav-price {
  font-size: 11px;
  color: #fff;
  font-weight: 600;
}

.db-fav-sparkline {
  width: 65px;
  height: 26px;
  flex-shrink: 0;
}

.db-fav-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  color: rgba(255, 255, 255, 0.3);
  font-size: 12px;
  text-align: center;
  grid-column: 1 / -1;
}

/* ===== Widget Grid ===== */

.db-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 14px;
  grid-auto-rows: 155px;
  position: relative;
}

/* Edit mode: visible grid background */
.db-grid.edit-mode {
  background: rgba(255, 255, 255, 0.01);
  border-radius: 16px;
  padding: 2px;
}

/* Empty cell drop zones — visible only in edit mode */
.db-grid-cell {
  border-radius: 12px;
  border: 1px dashed rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.02);
  transition: background 0.15s ease, border-color 0.15s ease;
  pointer-events: auto;
  z-index: 0;
}

.db-grid-cell.occupied {
  border-color: transparent;
  background: transparent;
  pointer-events: none;
}

.db-grid-cell.can-drop {
  border-color: rgba(139, 92, 246, 0.6);
  background: rgba(139, 92, 246, 0.12);
  box-shadow: inset 0 0 0 1px rgba(139, 92, 246, 0.3);
}

/* ===== Widget Card ===== */

.db-widget {
  background: rgba(30, 30, 50, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 14px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 1; /* sit above empty cell zones */
}

.db-widget:hover {
  border-color: rgba(255, 255, 255, 0.15);
}

.db-widget.edit-mode {
  border: 2px solid rgba(139, 92, 246, 0.4);
  cursor: grab;
}

.db-widget.edit-mode:active {
  cursor: grabbing;
}

.db-widget.dragging {
  opacity: 0.4;
  transform: scale(0.97);
}

.db-widget.drag-over {
  border-color: rgba(139, 92, 246, 0.7);
  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.4), 0 8px 24px rgba(139, 92, 246, 0.2);
}

.db-widget-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.db-widget.edit-mode .db-widget-content {
  pointer-events: none;
}

/* ===== Edit Mode Controls ===== */

.db-ctrl-drag {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: rgba(139, 92, 246, 0.8);
  border: 1px solid rgba(139, 92, 246, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  z-index: 10;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.4);
  transition: background 0.15s;
}

.db-ctrl-drag:hover { background: rgba(124, 58, 237, 0.9); }
.db-ctrl-drag:active { cursor: grabbing; }

.db-ctrl-delete {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: rgba(220, 38, 38, 0.8);
  border: 1px solid rgba(185, 28, 28, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.4);
  transition: background 0.15s;
}

.db-ctrl-delete:hover { background: rgba(185, 28, 28, 0.9); }

.db-ctrl-resize {
  position: absolute;
  bottom: 6px;
  right: 6px;
  height: 22px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 6px 0 4px;
  cursor: nwse-resize;
  z-index: 10;
  color: rgba(255, 255, 255, 0.35);
  transition: all 0.15s;
  -webkit-user-select: none;
          user-select: none;
}

.db-ctrl-resize:hover {
  background: rgba(139, 92, 246, 0.2);
  color: #c4b5fd;
}

.db-ctrl-resize-label {
  font-size: 9px;
  line-height: 1;
  letter-spacing: 0.02em;
  opacity: 0.7;
}

/* ===== Widget Content: Chart ===== */

.wg-chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  flex-shrink: 0;
  gap: 6px;
}

.wg-chart-name {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
  min-width: 0;
  cursor: pointer;
}

.wg-chart-name:hover { color: #fff; text-decoration: underline; text-decoration-color: rgba(255,255,255,0.3); }

.wg-chart-price { font-size: 13px; color: #fff; flex-shrink: 0; }
.wg-chart-price-lg { font-size: 17px; color: #fff; margin-bottom: 3px; }
.wg-chart-price-xl { font-size: 20px; color: #fff; margin-bottom: 3px; }

.wg-chart-change-up {
  font-size: 11px; color: #34d399;
  display: flex; align-items: center; gap: 2px; flex-shrink: 0;
}

.wg-chart-change-down {
  font-size: 11px; color: #f87171;
  display: flex; align-items: center; gap: 2px; flex-shrink: 0;
}

.wg-chart-area {
  flex: 1 1;
  min-height: 0;
  margin: 0 -4px;
}

/* ===== Widget Content: News ===== */

.wg-news-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.wg-news-title {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.wg-news-list {
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.wg-news-list::-webkit-scrollbar { width: 3px; }
.wg-news-list::-webkit-scrollbar-track { background: transparent; }
.wg-news-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }

.wg-news-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.wg-news-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(139, 92, 246, 0.3);
  transform: translateX(2px);
}

.wg-news-img {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.05);
}

.wg-news-body { flex: 1 1; min-width: 0; }

.wg-news-item-title {
  font-size: 11px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.85);
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 3px;
}

.wg-news-meta {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.3);
}

/* ===== Widget Content: Early Signals ===== */

.wg-signal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.wg-signal-title {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.wg-signal-list {
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.wg-signal-list::-webkit-scrollbar { width: 3px; }
.wg-signal-list::-webkit-scrollbar-track { background: transparent; }
.wg-signal-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }

.wg-signal-item {
  padding: 8px 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.wg-signal-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(139, 92, 246, 0.3);
}

.wg-signal-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}

.wg-signal-badges { display: flex; align-items: center; gap: 5px; }

.wg-signal-type {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 600;
}

.signal-type-market { color: #a78bfa; background: rgba(139,92,246,0.2); }
.signal-type-price { color: #34d399; background: rgba(52,211,153,0.2); }
.signal-type-supply { color: #60a5fa; background: rgba(96,165,250,0.2); }
.signal-type-regulatory { color: #fb923c; background: rgba(251,146,60,0.2); }

.wg-signal-impact {
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 10px;
  border: 1px solid transparent;
}

.impact-critical { color: #f87171; background: rgba(239,68,68,0.12); border-color: rgba(239,68,68,0.3); }
.impact-high { color: #fb923c; background: rgba(251,146,60,0.12); border-color: rgba(251,146,60,0.3); }
.impact-medium { color: #fbbf24; background: rgba(251,191,36,0.12); border-color: rgba(251,191,36,0.3); }
.impact-low { color: #60a5fa; background: rgba(96,165,250,0.12); border-color: rgba(96,165,250,0.3); }

.wg-signal-region {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.3);
}

.wg-signal-text {
  font-size: 11px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 5px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.wg-signal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 10px;
}

.wg-signal-time {
  display: flex;
  align-items: center;
  gap: 3px;
  color: #fb923c;
}

.wg-signal-category { color: rgba(255, 255, 255, 0.3); }

/* ===== Widget Content: Alerts ===== */

.wg-alerts-title {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  flex-shrink: 0;
  font-weight: 500;
}

.wg-alert-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 10px;
  margin-bottom: 6px;
  flex-shrink: 0;
}

.wg-alert-item.orange { background: rgba(251,146,60,0.08); border: 1px solid rgba(251,146,60,0.2); }
.wg-alert-item.blue   { background: rgba(96,165,250,0.08);  border: 1px solid rgba(96,165,250,0.2); }
.wg-alert-item.red    { background: rgba(239,68,68,0.08);   border: 1px solid rgba(239,68,68,0.2); }

.wg-alert-icon {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.wg-alert-icon.orange { background: rgba(251,146,60,0.15); }
.wg-alert-icon.blue   { background: rgba(96,165,250,0.15); }
.wg-alert-icon.red    { background: rgba(239,68,68,0.15); }

.wg-alert-body { flex: 1 1; min-width: 0; }
.wg-alert-name { font-size: 11px; color: rgba(255,255,255,0.9); margin-bottom: 2px; font-weight: 500; }
.wg-alert-desc { font-size: 10px; color: rgba(255,255,255,0.5); line-height: 1.3; }
.wg-alert-time { font-size: 10px; color: rgba(255,255,255,0.25); margin-top: 3px; }

/* ===== Widget Content: Activity ===== */

.wg-activity-title {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 14px;
  flex-shrink: 0;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.wg-stat { margin-bottom: 14px; }
.wg-stat-label { font-size: 11px; color: rgba(255,255,255,0.4); margin-bottom: 2px; }
.wg-stat-value { font-size: 22px; color: #fff; font-weight: 600; margin-bottom: 2px; }
.wg-stat-change-up      { font-size: 11px; color: #34d399; }
.wg-stat-change-neutral { font-size: 11px; color: #60a5fa; }

/* ===== Empty State ===== */

.db-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: rgba(255, 255, 255, 0.3);
  text-align: center;
  grid-column: 1 / -1;
}

.db-empty-icon { margin-bottom: 12px; opacity: 0.4; color: rgba(255,255,255,0.6); display: flex; justify-content: center; }
.db-empty-text { font-size: 15px; margin-bottom: 6px; color: rgba(255,255,255,0.5); }
.db-empty-sub  { font-size: 12px; color: rgba(255,255,255,0.3); margin-bottom: 16px; }

/* ===== Add Widget Modal ===== */

.db-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.db-modal {
  background: rgba(20, 20, 38, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  padding: 24px;
  width: 100%;
  max-width: 520px;
  max-height: 80vh;
  overflow-y: auto;
}

.db-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.db-modal-title {
  font-size: 15px;
  color: #fff;
  font-weight: 500;
}

.db-modal-close {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  transition: all 0.15s;
}

.db-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.db-widget-type-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.db-type-btn {
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(10px);
  cursor: pointer;
  text-align: left;
  transition: all 0.2s ease;
  color: #fff;
}

.db-type-btn:hover {
  background: rgba(139, 92, 246, 0.15);
  border-color: rgba(139, 92, 246, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.15);
}

.db-type-icon { font-size: 20px; margin-bottom: 8px; }
.db-type-name { font-size: 13px; color: #fff; margin-bottom: 3px; font-weight: 500; }
.db-type-desc { font-size: 11px; color: rgba(255, 255, 255, 0.45); }

.db-search-input {
  width: 100%;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #fff;
  font-size: 13px;
  font-family: inherit;
  outline: none;
  margin-bottom: 10px;
  box-sizing: border-box;
  transition: border-color 0.15s;
}

.db-search-input:focus {
  border-color: rgba(139, 92, 246, 0.5);
}

.db-search-input::placeholder { color: rgba(255, 255, 255, 0.3); }

.db-material-list {
  max-height: 300px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.db-material-list::-webkit-scrollbar { width: 4px; }
.db-material-list::-webkit-scrollbar-track { background: transparent; }
.db-material-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }

.db-material-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  border: 1px solid transparent;
}

.db-material-item:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.08);
}

.db-material-item-name { font-size: 13px; color: rgba(255,255,255,0.9); }
.db-material-item-code { font-size: 11px; color: rgba(255,255,255,0.35); margin-top: 1px; }
.db-material-item-price { font-size: 12px; color: rgba(255,255,255,0.55); flex-shrink: 0; }

/* ===== Delete Confirm Dialog ===== */

.db-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.db-confirm-box {
  background: rgba(20, 20, 38, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  padding: 24px;
  width: 100%;
  max-width: 380px;
}

.db-confirm-title {
  font-size: 15px;
  color: #fff;
  font-weight: 500;
  margin-bottom: 8px;
}

.db-confirm-text {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 20px;
  line-height: 1.5;
}

.db-confirm-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Dashboard/dashboard.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B,oFAAoF;;AAEpF;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA,8BAA8B;;AAE9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAO;EACP,YAAY;AACd;;AAEA,8BAA8B,aAAa,EAAE;;AAE7C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA,+BAA+B,aAAa,EAAE;AAC9C,uBAAuB,cAAc,EAAE;;AAEvC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA,8BAA8B;;AAE9B;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,+EAA+E;EAC/E,6CAA6C;EAC7C,8CAA8C;EAC9C,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,4BAA4B;;AAE5B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;AACd;;AAEA,sDAAsD;AACtD;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,0DAA0D;EAC1D,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA,4BAA4B;;AAE5B;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,mCAAmC;EACnC,UAAU,EAAE,+BAA+B;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,iFAAiF;AACnF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,mCAAmC;;AAEnC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA,sBAAsB,mCAAmC,EAAE;AAC3D,uBAAuB,gBAAgB,EAAE;;AAEzC;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA,wBAAwB,kCAAkC,EAAE;;AAE5D;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gCAAgC;EAChC,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,YAAY;EACZ,eAAe;AACjB;;AAEA,uBAAuB,WAAW,EAAE,0BAA0B,EAAE,4CAA4C,EAAE;;AAE9G,kBAAkB,eAAe,EAAE,WAAW,EAAE,cAAc,EAAE;AAChE,qBAAqB,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE;AACvE,qBAAqB,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE;;AAEvE;EACE,eAAe,EAAE,cAAc;EAC/B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc;AAC9D;;AAEA;EACE,eAAe,EAAE,cAAc;EAC/B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc;AAC9D;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,mCAAmC,UAAU,EAAE;AAC/C,yCAAyC,uBAAuB,EAAE;AAClE,yCAAyC,kCAAkC,EAAE,kBAAkB,EAAE;;AAEjG;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,qCAAqC;AACvC;;AAEA,gBAAgB,SAAO,EAAE,YAAY,EAAE;;AAEvC;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,8CAA8C;;AAE9C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,qCAAqC,UAAU,EAAE;AACjD,2CAA2C,uBAAuB,EAAE;AACpE,2CAA2C,kCAAkC,EAAE,kBAAkB,EAAE;;AAEnG;EACE,iBAAiB;EACjB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAElE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB,cAAc,EAAE,gCAAgC,EAAE;AACxE,qBAAqB,cAAc,EAAE,gCAAgC,EAAE;AACvE,sBAAsB,cAAc,EAAE,gCAAgC,EAAE;AACxE,0BAA0B,cAAc,EAAE,gCAAgC,EAAE;;AAE5E;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA,mBAAmB,cAAc,EAAE,gCAAgC,EAAE,iCAAiC,EAAE;AACxG,eAAe,cAAc,EAAE,iCAAiC,EAAE,kCAAkC,EAAE;AACtG,iBAAiB,cAAc,EAAE,iCAAiC,EAAE,kCAAkC,EAAE;AACxG,cAAc,cAAc,EAAE,iCAAiC,EAAE,kCAAkC,EAAE;;AAErG;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,sBAAsB,+BAA+B,EAAE;;AAEvD,uCAAuC;;AAEvC;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,wBAAwB,iCAAiC,EAAE,sCAAsC,EAAE;AACnG,wBAAwB,iCAAiC,GAAG,sCAAsC,EAAE;AACpG,wBAAwB,gCAAgC,IAAI,qCAAqC,EAAE;;AAEnG;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,wBAAwB,iCAAiC,EAAE;AAC3D,wBAAwB,iCAAiC,EAAE;AAC3D,wBAAwB,gCAAgC,EAAE;;AAE1D,iBAAiB,SAAO,EAAE,YAAY,EAAE;AACxC,iBAAiB,eAAe,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACtG,iBAAiB,eAAe,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AAClF,iBAAiB,eAAe,EAAE,6BAA6B,EAAE,eAAe,EAAE;;AAElF,yCAAyC;;AAEzC;EACE,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,WAAW,mBAAmB,EAAE;AAChC,iBAAiB,eAAe,EAAE,4BAA4B,EAAE,kBAAkB,EAAE;AACpF,iBAAiB,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACrF,0BAA0B,eAAe,EAAE,cAAc,EAAE;AAC3D,0BAA0B,eAAe,EAAE,cAAc,EAAE;;AAE3D,4BAA4B;;AAE5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iBAAiB,mBAAmB,EAAE,YAAY,EAAE,4BAA4B,EAAE,aAAa,EAAE,uBAAuB,EAAE;AAC1H,iBAAiB,eAAe,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AACpF,iBAAiB,eAAe,EAAE,4BAA4B,EAAE,mBAAmB,EAAE;;AAErF,iCAAiC;;AAEjC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,gBAAgB,eAAe,EAAE,kBAAkB,EAAE;AACrD,gBAAgB,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACpF,gBAAgB,eAAe,EAAE,gCAAgC,EAAE;;AAEnE;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,gCAAgC,+BAA+B,EAAE;;AAEjE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,uCAAuC,UAAU,EAAE;AACnD,6CAA6C,uBAAuB,EAAE;AACtE,6CAA6C,kCAAkC,EAAE,kBAAkB,EAAE;;AAErG;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA,yBAAyB,eAAe,EAAE,4BAA4B,EAAE;AACxE,yBAAyB,eAAe,EAAE,6BAA6B,EAAE,eAAe,EAAE;AAC1F,0BAA0B,eAAe,EAAE,6BAA6B,EAAE,cAAc,EAAE;;AAE1F,sCAAsC;;AAEtC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B","sourcesContent":["/* ===== Dashboard Page ===== */\n/* Matches the existing site design (charts-overview.css, chart-main.css patterns) */\n\n.db-page {\n  padding: 2rem;\n  background: transparent;\n  min-height: 100vh;\n  color: #ffffff;\n  box-sizing: border-box;\n}\n\n/* ===== Header / Tabs ===== */\n\n.db-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.db-tabs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  overflow-x: auto;\n  flex: 1;\n  min-width: 0;\n}\n\n.db-tabs::-webkit-scrollbar { display: none; }\n\n.db-tab {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(51, 51, 51, 0.3);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  cursor: pointer;\n  white-space: nowrap;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.7);\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.db-tab:hover {\n  background: rgba(75, 85, 99, 0.4);\n  border-color: rgba(255, 255, 255, 0.2);\n  color: #fff;\n}\n\n.db-tab.active {\n  background: rgba(139, 92, 246, 0.2);\n  border-color: rgba(139, 92, 246, 0.5);\n  color: #fff;\n  box-shadow: 0 4px 20px rgba(139, 92, 246, 0.2);\n}\n\n.db-tab-input {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(139, 92, 246, 0.5);\n  border-radius: 4px;\n  padding: 2px 8px;\n  color: #fff;\n  font-size: 13px;\n  font-family: inherit;\n  outline: none;\n  width: 120px;\n}\n\n.db-tab-delete {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: rgba(255, 100, 100, 0.7);\n  padding: 0;\n  margin-left: 2px;\n  font-size: 12px;\n  line-height: 1;\n  transition: all 0.15s;\n}\n\n.db-tab:hover .db-tab-delete { display: flex; }\n.db-tab-delete:hover { color: #f87171; }\n\n.db-tab-add {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(51, 51, 51, 0.3);\n  backdrop-filter: blur(10px);\n  cursor: pointer;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 18px;\n  line-height: 1;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.db-tab-add:hover {\n  background: rgba(139, 92, 246, 0.2);\n  border-color: rgba(139, 92, 246, 0.5);\n  color: #c4b5fd;\n}\n\n.db-edit-badge {\n  padding: 4px 10px;\n  background: rgba(139, 92, 246, 0.2);\n  border: 1px solid rgba(139, 92, 246, 0.4);\n  border-radius: 6px;\n  font-size: 11px;\n  color: #c4b5fd;\n  animation: db-pulse 2s infinite;\n}\n\n@keyframes db-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n.db-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.db-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 13px;\n  font-family: inherit;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.db-btn:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n\n.db-btn-primary {\n  background: rgba(139, 92, 246, 0.25);\n  border-color: rgba(139, 92, 246, 0.5);\n  color: #c4b5fd;\n}\n\n.db-btn-primary:hover {\n  background: rgba(139, 92, 246, 0.35);\n  border-color: rgba(139, 92, 246, 0.7);\n  color: #ddd6fe;\n}\n\n.db-btn-danger {\n  background: rgba(239, 68, 68, 0.15);\n  border-color: rgba(239, 68, 68, 0.4);\n  color: #fca5a5;\n}\n\n.db-btn-danger:hover {\n  background: rgba(239, 68, 68, 0.25);\n  border-color: rgba(239, 68, 68, 0.6);\n}\n\n/* ===== Favorites Bar ===== */\n\n.db-favorites {\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 20px 20px 16px;\n  margin-bottom: 1.5rem;\n  box-shadow: -2px 0 2px rgba(255,255,255,0.15), 2px 0 2px rgba(255,255,255,0.15);\n  border-left: 1px solid rgba(255,255,255,0.08);\n  border-right: 1px solid rgba(255,255,255,0.08);\n  border-top: 1px solid rgba(255,255,255,0.04);\n  border-bottom: 1px solid rgba(255,255,255,0.04);\n}\n\n.db-favorites-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 14px;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.55);\n  font-weight: 500;\n}\n\n.db-favorites-grid {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.db-favorites-grid::-webkit-scrollbar {\n  display: none;\n}\n\n.db-fav-card {\n  flex: 1 1 170px;\n  min-width: 160px;\n  max-width: 220px;\n  background: rgba(30, 30, 50, 0.5);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.db-fav-card:hover {\n  background: rgba(40, 40, 60, 0.7);\n  border-color: rgba(139, 92, 246, 0.4);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.15);\n}\n\n.db-fav-name {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.8);\n  font-weight: 500;\n  margin-bottom: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.db-fav-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n}\n\n.db-fav-price {\n  font-size: 11px;\n  color: #fff;\n  font-weight: 600;\n}\n\n.db-fav-sparkline {\n  width: 65px;\n  height: 26px;\n  flex-shrink: 0;\n}\n\n.db-fav-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 60px;\n  color: rgba(255, 255, 255, 0.3);\n  font-size: 12px;\n  text-align: center;\n  grid-column: 1 / -1;\n}\n\n/* ===== Widget Grid ===== */\n\n.db-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 14px;\n  grid-auto-rows: 155px;\n  position: relative;\n}\n\n/* Edit mode: visible grid background */\n.db-grid.edit-mode {\n  background: rgba(255, 255, 255, 0.01);\n  border-radius: 16px;\n  padding: 2px;\n}\n\n/* Empty cell drop zones — visible only in edit mode */\n.db-grid-cell {\n  border-radius: 12px;\n  border: 1px dashed rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.02);\n  transition: background 0.15s ease, border-color 0.15s ease;\n  pointer-events: auto;\n  z-index: 0;\n}\n\n.db-grid-cell.occupied {\n  border-color: transparent;\n  background: transparent;\n  pointer-events: none;\n}\n\n.db-grid-cell.can-drop {\n  border-color: rgba(139, 92, 246, 0.6);\n  background: rgba(139, 92, 246, 0.12);\n  box-shadow: inset 0 0 0 1px rgba(139, 92, 246, 0.3);\n}\n\n/* ===== Widget Card ===== */\n\n.db-widget {\n  background: rgba(30, 30, 50, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 14px;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  z-index: 1; /* sit above empty cell zones */\n}\n\n.db-widget:hover {\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n.db-widget.edit-mode {\n  border: 2px solid rgba(139, 92, 246, 0.4);\n  cursor: grab;\n}\n\n.db-widget.edit-mode:active {\n  cursor: grabbing;\n}\n\n.db-widget.dragging {\n  opacity: 0.4;\n  transform: scale(0.97);\n}\n\n.db-widget.drag-over {\n  border-color: rgba(139, 92, 246, 0.7);\n  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.4), 0 8px 24px rgba(139, 92, 246, 0.2);\n}\n\n.db-widget-content {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.db-widget.edit-mode .db-widget-content {\n  pointer-events: none;\n}\n\n/* ===== Edit Mode Controls ===== */\n\n.db-ctrl-drag {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  background: rgba(139, 92, 246, 0.8);\n  border: 1px solid rgba(139, 92, 246, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: grab;\n  z-index: 10;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.4);\n  transition: background 0.15s;\n}\n\n.db-ctrl-drag:hover { background: rgba(124, 58, 237, 0.9); }\n.db-ctrl-drag:active { cursor: grabbing; }\n\n.db-ctrl-delete {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  background: rgba(220, 38, 38, 0.8);\n  border: 1px solid rgba(185, 28, 28, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 10;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.4);\n  transition: background 0.15s;\n}\n\n.db-ctrl-delete:hover { background: rgba(185, 28, 28, 0.9); }\n\n.db-ctrl-resize {\n  position: absolute;\n  bottom: 6px;\n  right: 6px;\n  height: 22px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 6px 0 4px;\n  cursor: nwse-resize;\n  z-index: 10;\n  color: rgba(255, 255, 255, 0.35);\n  transition: all 0.15s;\n  user-select: none;\n}\n\n.db-ctrl-resize:hover {\n  background: rgba(139, 92, 246, 0.2);\n  color: #c4b5fd;\n}\n\n.db-ctrl-resize-label {\n  font-size: 9px;\n  line-height: 1;\n  letter-spacing: 0.02em;\n  opacity: 0.7;\n}\n\n/* ===== Widget Content: Chart ===== */\n\n.wg-chart-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 6px;\n  flex-shrink: 0;\n  gap: 6px;\n}\n\n.wg-chart-name {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.8);\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  min-width: 0;\n  cursor: pointer;\n}\n\n.wg-chart-name:hover { color: #fff; text-decoration: underline; text-decoration-color: rgba(255,255,255,0.3); }\n\n.wg-chart-price { font-size: 13px; color: #fff; flex-shrink: 0; }\n.wg-chart-price-lg { font-size: 17px; color: #fff; margin-bottom: 3px; }\n.wg-chart-price-xl { font-size: 20px; color: #fff; margin-bottom: 3px; }\n\n.wg-chart-change-up {\n  font-size: 11px; color: #34d399;\n  display: flex; align-items: center; gap: 2px; flex-shrink: 0;\n}\n\n.wg-chart-change-down {\n  font-size: 11px; color: #f87171;\n  display: flex; align-items: center; gap: 2px; flex-shrink: 0;\n}\n\n.wg-chart-area {\n  flex: 1;\n  min-height: 0;\n  margin: 0 -4px;\n}\n\n/* ===== Widget Content: News ===== */\n\n.wg-news-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  flex-shrink: 0;\n}\n\n.wg-news-title {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.55);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n}\n\n.wg-news-list {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.wg-news-list::-webkit-scrollbar { width: 3px; }\n.wg-news-list::-webkit-scrollbar-track { background: transparent; }\n.wg-news-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }\n\n.wg-news-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.wg-news-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(139, 92, 246, 0.3);\n  transform: translateX(2px);\n}\n\n.wg-news-img {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  object-fit: cover;\n  flex-shrink: 0;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.wg-news-body { flex: 1; min-width: 0; }\n\n.wg-news-item-title {\n  font-size: 11px;\n  line-height: 1.4;\n  color: rgba(255, 255, 255, 0.85);\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  margin-bottom: 3px;\n}\n\n.wg-news-meta {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.3);\n}\n\n/* ===== Widget Content: Early Signals ===== */\n\n.wg-signal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  flex-shrink: 0;\n}\n\n.wg-signal-title {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.55);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n}\n\n.wg-signal-list {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.wg-signal-list::-webkit-scrollbar { width: 3px; }\n.wg-signal-list::-webkit-scrollbar-track { background: transparent; }\n.wg-signal-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }\n\n.wg-signal-item {\n  padding: 8px 10px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.wg-signal-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(139, 92, 246, 0.3);\n}\n\n.wg-signal-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 5px;\n}\n\n.wg-signal-badges { display: flex; align-items: center; gap: 5px; }\n\n.wg-signal-type {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 5px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.signal-type-market { color: #a78bfa; background: rgba(139,92,246,0.2); }\n.signal-type-price { color: #34d399; background: rgba(52,211,153,0.2); }\n.signal-type-supply { color: #60a5fa; background: rgba(96,165,250,0.2); }\n.signal-type-regulatory { color: #fb923c; background: rgba(251,146,60,0.2); }\n\n.wg-signal-impact {\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  border: 1px solid transparent;\n}\n\n.impact-critical { color: #f87171; background: rgba(239,68,68,0.12); border-color: rgba(239,68,68,0.3); }\n.impact-high { color: #fb923c; background: rgba(251,146,60,0.12); border-color: rgba(251,146,60,0.3); }\n.impact-medium { color: #fbbf24; background: rgba(251,191,36,0.12); border-color: rgba(251,191,36,0.3); }\n.impact-low { color: #60a5fa; background: rgba(96,165,250,0.12); border-color: rgba(96,165,250,0.3); }\n\n.wg-signal-region {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.wg-signal-text {\n  font-size: 11px;\n  line-height: 1.4;\n  color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 5px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.wg-signal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 10px;\n}\n\n.wg-signal-time {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  color: #fb923c;\n}\n\n.wg-signal-category { color: rgba(255, 255, 255, 0.3); }\n\n/* ===== Widget Content: Alerts ===== */\n\n.wg-alerts-title {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.55);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 12px;\n  flex-shrink: 0;\n  font-weight: 500;\n}\n\n.wg-alert-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 9px 10px;\n  border-radius: 10px;\n  margin-bottom: 6px;\n  flex-shrink: 0;\n}\n\n.wg-alert-item.orange { background: rgba(251,146,60,0.08); border: 1px solid rgba(251,146,60,0.2); }\n.wg-alert-item.blue   { background: rgba(96,165,250,0.08);  border: 1px solid rgba(96,165,250,0.2); }\n.wg-alert-item.red    { background: rgba(239,68,68,0.08);   border: 1px solid rgba(239,68,68,0.2); }\n\n.wg-alert-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.wg-alert-icon.orange { background: rgba(251,146,60,0.15); }\n.wg-alert-icon.blue   { background: rgba(96,165,250,0.15); }\n.wg-alert-icon.red    { background: rgba(239,68,68,0.15); }\n\n.wg-alert-body { flex: 1; min-width: 0; }\n.wg-alert-name { font-size: 11px; color: rgba(255,255,255,0.9); margin-bottom: 2px; font-weight: 500; }\n.wg-alert-desc { font-size: 10px; color: rgba(255,255,255,0.5); line-height: 1.3; }\n.wg-alert-time { font-size: 10px; color: rgba(255,255,255,0.25); margin-top: 3px; }\n\n/* ===== Widget Content: Activity ===== */\n\n.wg-activity-title {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.45);\n  margin-bottom: 14px;\n  flex-shrink: 0;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.wg-stat { margin-bottom: 14px; }\n.wg-stat-label { font-size: 11px; color: rgba(255,255,255,0.4); margin-bottom: 2px; }\n.wg-stat-value { font-size: 22px; color: #fff; font-weight: 600; margin-bottom: 2px; }\n.wg-stat-change-up      { font-size: 11px; color: #34d399; }\n.wg-stat-change-neutral { font-size: 11px; color: #60a5fa; }\n\n/* ===== Empty State ===== */\n\n.db-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: rgba(255, 255, 255, 0.3);\n  text-align: center;\n  grid-column: 1 / -1;\n}\n\n.db-empty-icon { margin-bottom: 12px; opacity: 0.4; color: rgba(255,255,255,0.6); display: flex; justify-content: center; }\n.db-empty-text { font-size: 15px; margin-bottom: 6px; color: rgba(255,255,255,0.5); }\n.db-empty-sub  { font-size: 12px; color: rgba(255,255,255,0.3); margin-bottom: 16px; }\n\n/* ===== Add Widget Modal ===== */\n\n.db-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.65);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.db-modal {\n  background: rgba(20, 20, 38, 0.95);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 20px;\n  padding: 24px;\n  width: 100%;\n  max-width: 520px;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.db-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.db-modal-title {\n  font-size: 15px;\n  color: #fff;\n  font-weight: 500;\n}\n\n.db-modal-close {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.6);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  transition: all 0.15s;\n}\n\n.db-modal-close:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n.db-widget-type-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n}\n\n.db-type-btn {\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.04);\n  backdrop-filter: blur(10px);\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.2s ease;\n  color: #fff;\n}\n\n.db-type-btn:hover {\n  background: rgba(139, 92, 246, 0.15);\n  border-color: rgba(139, 92, 246, 0.4);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.15);\n}\n\n.db-type-icon { font-size: 20px; margin-bottom: 8px; }\n.db-type-name { font-size: 13px; color: #fff; margin-bottom: 3px; font-weight: 500; }\n.db-type-desc { font-size: 11px; color: rgba(255, 255, 255, 0.45); }\n\n.db-search-input {\n  width: 100%;\n  padding: 10px 14px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  color: #fff;\n  font-size: 13px;\n  font-family: inherit;\n  outline: none;\n  margin-bottom: 10px;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n}\n\n.db-search-input:focus {\n  border-color: rgba(139, 92, 246, 0.5);\n}\n\n.db-search-input::placeholder { color: rgba(255, 255, 255, 0.3); }\n\n.db-material-list {\n  max-height: 300px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.db-material-list::-webkit-scrollbar { width: 4px; }\n.db-material-list::-webkit-scrollbar-track { background: transparent; }\n.db-material-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }\n\n.db-material-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 9px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s;\n  border: 1px solid transparent;\n}\n\n.db-material-item:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.db-material-item-name { font-size: 13px; color: rgba(255,255,255,0.9); }\n.db-material-item-code { font-size: 11px; color: rgba(255,255,255,0.35); margin-top: 1px; }\n.db-material-item-price { font-size: 12px; color: rgba(255,255,255,0.55); flex-shrink: 0; }\n\n/* ===== Delete Confirm Dialog ===== */\n\n.db-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.65);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.db-confirm-box {\n  background: rgba(20, 20, 38, 0.95);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 20px;\n  padding: 24px;\n  width: 100%;\n  max-width: 380px;\n}\n\n.db-confirm-title {\n  font-size: 15px;\n  color: #fff;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.db-confirm-text {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.5);\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n.db-confirm-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
